<div class="delete-query-container">
    <form [formGroup]="deleteQueryForm" (ngSubmit)="onDeleteQuery()">
      <div class="form-group">
        <label for="deleteComments">Comments for Deletion</label>        
        <textarea nz-input
          id="deleteComments"
          formControlName="deleteComments"          
          class="form-control"
          [maxlength]="maxCharacters"
          placeholder="Enter your comments for deleting this query"
          rows="4"
        ></textarea>
        <!-- Character Counter -->
        <div class="character-counter">
            <small>
            {{ deleteQueryForm.get('deleteComments')?.value?.length || 0 }}/{{maxCharacters}} characters
            </small>
        </div>

        <!-- Validation Messages -->
         
        <div *ngIf="deleteQueryForm.get('deleteComments')?.touched && deleteQueryForm.get('deleteComments')?.invalid">
          <small class="text-danger" *ngIf="deleteQueryForm.get('deleteComments')?.errors?.['required']">
            Comments are required.
          </small>
          <small class="text-danger" *ngIf="deleteQueryForm.get('deleteComments')?.errors?.['maxlength']">
            Comments cannot exceed {{maxCharacters}} characters.
          </small>
        </div>
      </div>
      <div nz-row>
        <div nz-col nzSpan="18"></div>
        <div nz-col nzSpan="6">
          <div class="button-container" style="display: flex; justify-content: flex-end; align-items: center; float: right;">
            <button nz-button nzType="primary" type="submit" style="margin-right: 10px;" [disabled]="deleteQueryForm.invalid">
              Delete Query
            </button>
            <button nz-button nzType="primary" type="button" (click)="onCancel()">
              Cancel
            </button>
          </div>
        </div>
      </div>
      <!-- <div class="form-actions button-container" >
        <button nz-button nzType="primary" type="submit" class="btn btn-danger" [disabled]="deleteQueryForm.invalid">
          Delete Query
        </button>
        <button type="button" class="btn btn-secondary" (click)="onCancel()">
          Cancel
        </button>
      </div> -->
    </form>
  </div>